import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

class SeasonAdmin_nav extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			season: this.props.season,
		};
	
		// this.dummyfunction = this.dummyfunction.bind(this);
	}

 	componentDidMount() {
		//console.log('SeasonAdmin_nav: componentDidMount');
		this.setState({
			season: this.props.season
		});		
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('SeasonAdmin_nav: UNSAFE_componentWillReceiveProps');
		// console.log(nextProps);
		this.setState({
			season: nextProps.season
		});	
	}

  render() {
		// console.log('SeasonAdmin_nav: RENDER');
		// console.log(this.props.adminAccess);

		if (this.props.adminAccess.adminValidatedAccessLevel <= ADMIN_LVL_SEASONS) {
		return (
	    <div>
				<h5><b>Saison:&nbsp;&nbsp;</b> {this.state.season.name}
				{(this.props.adminAccess.globalAccessLevel === ADMIN_LVL_MASTER) ? " ["+this.state.season._id+"]" : null}
				</h5>

				<div className="row">
				<div className="col-md-12">
					<Link to="/admsafe/season" className="btn btn-primary btnlink-green"> 
						Paramètres généraux </Link> &nbsp;&nbsp;&nbsp;&nbsp;
					<Link to="/admsafe/season/subs" className="btn btn-primary btnlink-green">
						Sous-saisons et Divisions</Link> &nbsp;&nbsp;&nbsp;&nbsp;
					<Link to="/admsafe/season/eqcfg" className="btn btn-primary btnlink-green">
						Équipes et substituts</Link> &nbsp;&nbsp;&nbsp;&nbsp;

					{(this.props.adminAccess.charterAdmin.indexOf('QVNEA') !== -1) ?
						<Link to="/admsafe/season/qvneaSummary" className="btn btn-qvnea">
							QVNEA Sommaire</Link>
					: null}

				</div>
				</div>
				<br/>
	    </div>
	  );

		} else {
			return (<div></div>)
		}
  }

}

export default SeasonAdmin_nav;
